import styles from "./Footer.module.css";
import { useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";


const Footer = () => {
  const pathname = useLocation().pathname
  const User = useSelector(state => state.User)
  const {user_type} = User
  return (
    // <section className={styles.container} style={{justifyContent:"center"}}>
      <footer className="mt-auto bg-gray-100 text-center py-3 text-sm text-gray-600">
      Copyright 2026 AuthBridge, All Rights Reserved.
  </footer>
    // </section>
  );
};

export default Footer;
